import { ReactNode, useState } from 'react';
import * as Popover from '@radix-ui/react-popover';

interface Props {
  icon: ReactNode;
  count: number;
  ariaLabel: string;
  panelTitle: string;
  children: (close: () => void) => ReactNode;
}

export default function NotificationBell({
  icon,
  count,
  ariaLabel,
  panelTitle,
  children,
}: Props) {
  const [open, setOpen] = useState(false);
  const display = count > 9 ? '9+' : String(count);

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <button
          type="button"
          aria-label={ariaLabel}
          className="gt-bell-button"
          style={{
            position: 'relative',
            background: 'transparent',
            border: 0,
            padding: 6,
            cursor: 'pointer',
            color: 'inherit',
          }}
        >
          {icon}
          {count > 0 && (
            <span
              aria-hidden
              style={{
                position: 'absolute',
                top: 2,
                right: 2,
                minWidth: 16,
                height: 16,
                padding: '0 4px',
                borderRadius: 8,
                background: '#dc2626',
                color: 'white',
                fontSize: 10,
                lineHeight: '16px',
                fontWeight: 600,
                textAlign: 'center',
              }}
            >
              {display}
            </span>
          )}
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          side="right"
          align="start"
          sideOffset={8}
          style={{
            width: 360,
            maxHeight: 480,
            background: 'var(--gt-surface, #fff)',
            border: '1px solid var(--gt-divider, rgba(0,0,0,.08))',
            borderRadius: 12,
            boxShadow: '0 10px 30px rgba(0,0,0,.12)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            zIndex: 50,
          }}
        >
          <div
            style={{
              padding: '12px 14px',
              fontWeight: 600,
              fontSize: 14,
              borderBottom: '1px solid var(--gt-divider, rgba(0,0,0,.06))',
            }}
          >
            {panelTitle}
          </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {children(() => setOpen(false))}
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
